import _ from 'lodash';
import React from 'react';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { ThemeProvider } from 'styled-components';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import Loading from '../../../shared/loading';
import { Container, ContentContainer } from '../shared/styles';
import { useGetBanners } from '../../../services/lwadmin/homepage/banner-service';
import Actions from './homepage-components/actions';
import Header from './homepage-components/header';
import Banner from './homepage-components/banner';

export default function Homepage() {
  const [banners, setBanners] = React.useState([]);
  const [{ loading }, get] = useGetBanners();
  const loadingRef = React.useRef();

  useChangeAwareEffect(({ isMount }) => {
    isMount && get().then(({ data }) => setBanners(_.get(data, 'banners', [])));
  }, {});

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  return (
    <ThemeProvider theme={theme}>
      <Container>
        <ContentContainer>
          <h1>Banners</h1>
          <Header />
          <Loading ref={loadingRef}>
            {banners.map(bn => <Banner key={bn.id} banner={bn} />)}
          </Loading>
        </ContentContainer>
        <Actions />
      </Container>
    </ThemeProvider>
  );
}
